import styled, { css } from 'styled-components';
import { BodyShort01, ProductiveHeading05 } from 'components/styles';

export const ChannelDetailsWrapper = styled.div`
  padding: var(--spacing-06);
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--gray-10);
  margin-bottom: var(--spacing-05);
`;

export const Heading = styled.div`
  ${ProductiveHeading05};
  margin-bottom: var(--spacing-03);
`;

export const Body = styled.div<{ isRTE?: boolean }>`
  ${BodyShort01};
  max-height: 150px;
  height: fit-content;
  overflow: hidden;
  margin-bottom: var(--spacing-05);
  .mention {
    background-color: var(--cyan-10);
    color: var(--blue-70);
    padding: 0 var(--spacing-01);
  }
  .mention.mention__self {
    background: var(--purple-20);
  }
  ${({ isRTE }) =>
    isRTE &&
    css`
      cursor: pointer;
      background-color: var(--gray-10);
      transition: background-color 0.5s ease-in-out;
      padding-bottom: var(--spacing-02);
      * {
        background-color: var(--gray-10) !important;
        cursor: pointer !important;
        --rte-min-height: fit-content;
        transition: background-color 0.5s ease-in-out;
      }
      *:not(li) {
        overflow: hidden !important;
      }
    `};
`;

export const Links = styled.div`
  ${BodyShort01};
  display: flex;
  align-items: center;
`;
